/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gold_Coral_Whale_AidInputs */

const en_gold_coral_whale_aid = /** @type {(inputs: Gold_Coral_Whale_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share for reports`)
};

const de_gold_coral_whale_aid = /** @type {(inputs: Gold_Coral_Whale_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Berichte freigeben`)
};

/**
* | output |
* | --- |
* | "Share for reports" |
*
* @param {Gold_Coral_Whale_AidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gold_coral_whale_aid = /** @type {((inputs?: Gold_Coral_Whale_AidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gold_Coral_Whale_AidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gold_coral_whale_aid(inputs)
	return de_gold_coral_whale_aid(inputs)
});